import { Font } from '@react-pdf/renderer';

import InterRegular from '../../../assets/fonts/Inter-Regular.ttf';
import InterBold from '../../../assets/fonts/Inter-Bold.ttf';

import LoraRegular from '../../../assets/fonts/Lora-Regular.ttf';
import LoraBold from '../../../assets/fonts/Lora-Bold.ttf';
import LoraItalic from '../../../assets/fonts/Lora-Italic.ttf';

import RobotoRegular from '../../../assets/fonts/Roboto-Regular.ttf';
import RobotoBold from '../../../assets/fonts/Roboto-Bold.ttf';
import RobotoItalic from '../../../assets/fonts/Roboto-Italic.ttf';

import RobotoMonoRegular from '../../../assets/fonts/RobotoMono-Regular.ttf';
import RobotoMonoBold from '../../../assets/fonts/RobotoMono-Bold.ttf';

let fontsRegistered = false;

const resolveFontSrc = (src) => {
  if (typeof src === 'string' && src.startsWith('/src/')) {
    if (typeof process !== 'undefined' && typeof process.cwd === 'function') {
      return process.cwd() + src;
    }
  }
  return src;
};

export const registerFonts = () => {
  if (fontsRegistered) return;

  // Globally disable mid-word hyphenation (e.g. Accessibility -> Acces-sibility)
  Font.registerHyphenationCallback(word => [word]);

  // Inter - Clean, modern Sans-serif
  Font.register({
    family: 'Inter',
    fonts: [
      { src: resolveFontSrc(InterRegular), fontWeight: 400 },
      { src: resolveFontSrc(InterBold), fontWeight: 700 },
      { src: resolveFontSrc(InterRegular), fontStyle: 'italic', fontWeight: 400 },
      { src: resolveFontSrc(InterBold), fontStyle: 'italic', fontWeight: 700 }
    ]
  });

  // Lora - Elegant Serif
  Font.register({
    family: 'Lora',
    fonts: [
      { src: resolveFontSrc(LoraRegular), fontWeight: 400 },
      { src: resolveFontSrc(LoraBold), fontWeight: 700 },
      { src: resolveFontSrc(LoraItalic), fontStyle: 'italic', fontWeight: 400 }
    ]
  });

  // Roboto - Technical Sans-serif
  Font.register({
    family: 'Roboto',
    fonts: [
      { src: resolveFontSrc(RobotoRegular), fontWeight: 400 },
      { src: resolveFontSrc(RobotoBold), fontWeight: 700 },
      { src: resolveFontSrc(RobotoItalic), fontStyle: 'italic', fontWeight: 400 }
    ]
  });

  // Roboto Mono
  Font.register({
    family: 'Roboto Mono',
    fonts: [
      { src: resolveFontSrc(RobotoMonoRegular), fontWeight: 400 },
      { src: resolveFontSrc(RobotoMonoBold), fontWeight: 700 },
      { src: resolveFontSrc(RobotoMonoRegular), fontStyle: 'italic', fontWeight: 400 },
      { src: resolveFontSrc(RobotoMonoBold), fontStyle: 'italic', fontWeight: 700 }
    ]
  });

  fontsRegistered = true;
};
